"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcuantFieldToJSON = exports.AcuantFieldFromJSONTyped = exports.AcuantFieldFromJSON = void 0;
function AcuantFieldFromJSON(json) {
    return AcuantFieldFromJSONTyped(json, false);
}
exports.AcuantFieldFromJSON = AcuantFieldFromJSON;
function AcuantFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': json['value'],
        'reliability': json['reliability'],
        'name': json['name'],
    };
}
exports.AcuantFieldFromJSONTyped = AcuantFieldFromJSONTyped;
function AcuantFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'reliability': value.reliability,
        'name': value.name,
    };
}
exports.AcuantFieldToJSON = AcuantFieldToJSON;
//# sourceMappingURL=AcuantField.js.map